// mega-menu-carousel.js

import { EffectCarousel } from './theme.js'; 

var MegaMenuPromoCarousel = class extends EffectCarousel {
  
  // CRITICAL FIX: We are OVERRIDING the base class's connectedCallback.
  // We DO NOT call super.connectedCallback() because that is what causes the crash.
  connectedCallback() {
      // 1. Run the base class's constructor/setup logic *safely* (if required by EffectCarousel).
      // Since super.connectedCallback() is the problem, we rely on the component's creation
      // to handle the initial setup of this.items and this.selectedIndex.
      
      // 2. We only execute our safe custom logic after a small delay,
      // giving the DOM a moment to be complete.
      setTimeout(() => {
          this._runCustomLogic();
      }, 0); 
  }
  
  // Custom logic to handle color updates (your original, safe code)
  _runCustomLogic() {
      // We assume this.items and this.selectedIndex are now set up.
      
      // Safety Check 1: Ensure the controls wrapper (nextElementSibling) is present.
      if (this.nextElementSibling) {
        this.addEventListener("carousel:select", (event) => this._updateControlsColor(event.detail.slide));
        
        // Safety Check 2: Only proceed if the 'items' collection exists AND has elements.
        if (this.items && this.items.length > 0) {
          this._updateControlsColor(this.items[this.selectedIndex]);
        } else {
            // This is logged on pages where the menu is present but unconfigured.
            console.warn("MegaMenuPromoCarousel component found but has no items configured.");
        }
      }
  }

  _updateControlsColor(slide) {
    if (!slide || !this.nextElementSibling) {
      return; 
    }
    
    const extractFrom = slide.classList.contains("content-over-media") ? slide : slide.firstElementChild;
    
    if (!extractFrom) {
      return;
    }

    this.nextElementSibling.style.setProperty("--text-color", extractFrom.style.getPropertyValue("--text-color"));
  }
  
  // The base class likely contains a render() or update() method. 
  // We leave other base methods untouched unless they also crash.

};

if (!window.customElements.get("mega-menu-promo-carousel")) {
  window.customElements.define("mega-menu-promo-carousel", MegaMenuPromoCarousel);
}